<template>
  <div v-if="media" class="network-feed row">
    <div v-if="media" :class="displaySize === 'big' ? 'g-3' : 'g-0'" class="row">
      <div v-for="(m, i) in media" :key="'card-' + m.id + '-' + m.type" :class="columnClass">
        <CardFull v-if="displaySize === 'big'" :columns="columns" :index="i" :media="m" :network="network" />
        <CardSmall v-else :columns="columns" :index="i" :media="m" :network="network" />
      </div>
    </div>
  </div>
</template>
<script>
import CardFull from './card/CardFull.vue';
import CardSmall from './card/CardSmall.vue';

export default {
  components: {
    CardFull,
    CardSmall,
  },
  props: {
    media: {
      type: Array,
      default: null,
    },
    columns: {
      type: Array,
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
    displaySize: {
      type: String,
      default: null,
    },
  },
  computed: {
    cardColumnClass: function () {
      if (this.columns === 3) return 'col-xl-3 col-lg-3 col-md-3 col-sm-6';
      if (this.columns === 6) return 'col-xl-6 col-lg-6 col-md-6 col-sm-6';
      return 'col-' + this.columns;
    },
    columnClass: function () {
      if (this.displaySize === 'big') {
        return 'col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4';
      } else if (this.displaySize === 'medium') {
        return 'col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12';
      } else {
        return 'col-xxl-6 col-xl-6 col-lg-12 col-md-4 col-sm-4';
      }
    },
  },
};
</script>
<style scoped>
@media(min-width:1400px) and (max-width: 2000px){
  .col-xxl-2 {
    width: 25%;
  }
}
@media(min-width:400px) and (max-width: 600px){
  .network-feed .row .col-sm-4 {
    width: 50%;
  }
}
</style>